<template>
  <div class="choose-sch">
    <Modal v-model="show" title="选择课程提供方" :width="modalWidth">
      <div style="min-height: 300px">
        <div v-if="show">
          <RemarkCard style="margin-bottom: 10px">
            <p>请根据入账主体选择对应的机构，不可选错！点击搜索立即查询</p>
          </RemarkCard>
          <div class="flex align-items" style="margin-bottom: 10px">
            <span class="color-red" style="margin-right: 4px">*</span>请选择资金入账方：
            {{ inAccountType != 3 ? acctName : `${wxMchName}(${wxMchId})` }}
            <Button
              v-if="inAccountType != 3"
              type="primary"
              size="small"
              style="margin-left: 10px"
              :disabled="configTableList.length > 0"
              @click="handleSelect"
            >请选择</Button>
          </div>
          <div class="flex justify-content_end" style="margin-bottom: 10px">
            <Button
              type="primary"
              size="small"
              @click="handleApply"
            >选择课程提供方</Button>
          </div>
          <div class="table-main" style="margin-bottom: 10px">
            <Table
              :columns="tableColumn"
              :max-height="500"
              :data="tableData"
              border
            >
              <template slot="orgType" slot-scope="{ row, index }">
                <span>{{ orgTypeKeyValue[row.orgType] }}</span>
              </template>
              <template slot="divideChannel" slot-scope="{ row, index }">
                <div class="flex align-items" @click="handleClickRow(index)">
                  <Select
                    v-model="tableData[index]['divideChannel']"
                    placeholder="请选择结算方式"
                    :transfer="true"
                    style="width: 120px"
                    disabled
                    @on-change="onDivideChannelChange"
                  >
                    <Option
                      v-for="item in accountTypeList"
                      :key="item.value"
                      :value="item.value"
                    >{{ item.name }}</Option>
                  </Select>
                </div>
              </template>
              <!-- v-if="tableData[index]['divideChannel'] == 2"      -->

              <template slot="proportion1" slot-scope="{ row, index }">
                <div class="flex align-items">
                  <Input
                    v-model="tableData[index]['proportion1']"
                    placeholder="课程方分账比例"
                    style="width: 60px"
                    @on-blur="getProportion1Input(index)"
                  ></Input>
                  <span style="margin-left: 8px"> %</span>
                  <Icon
                    v-if="index == 0"
                    type="md-arrow-round-down"
                    style="margin-left: 8px"
                    class="cursor-pointer"
                    @click="handleProportionCopy1()"
                  ></Icon>
                </div>
                <!-- <div v-else>--</div> -->
              </template>
              <template slot="proportion2" slot-scope="{ row, index }">
                <!-- v-if="tableData[index]['divideChannel'] == 2" -->
                <div class="flex align-items">
                  <Input
                    v-model="tableData[index]['proportion2']"
                    placeholder="平台方分账比例"
                    style="width: 60px"
                  ></Input>
                  <Icon
                    v-if="index == 0"
                    type="md-arrow-round-down"
                    style="margin-left: 8px"
                    class="cursor-pointer"
                    @click="handleProportionCopy2()"
                  ></Icon>
                  <span style="margin-left: 8px"> %</span>
                </div>
                <!-- <div v-else>--</div> -->
              </template>
              <template slot="proportion3" slot-scope="{ row, index }">
                <!-- v-if="tableData[index]['divideChannel'] == 2" -->
                <div style="padding-top: 10px">
                  <div
                    v-for="(item, index_1) in row.otherProportions"
                    :key="index_1"
                    class="flex align-items"
                    style="margin-bottom: 10px"
                  >
                    <div
                      v-if="item['otherOrgAction']"
                      class="flex align-items justify-space_between"
                      style="width: 210px; flex: 0 0 auto"
                    >
                      <div class="flex align-items">
                        <p class="cursor-pointer">
                          <Tooltip
                            :content="item.otherOrgName"
                            :transfer="true"
                          >
                            <p class="otherOrgName">{{ item.otherOrgName }}</p>
                          </Tooltip>
                        </p>
                        <Input
                          v-model="
                            tableData[index]['otherProportions'][index_1][
                              'proportion'
                            ]
                          "
                          placeholder="分账比例"
                          style="width: 60px"
                        ></Input>
                        <span style="margin-left: 8px"> %</span>
                        <Icon
                          v-if="showCopyIcon(index, index_1)"
                          type="md-arrow-round-down"
                          style="margin-left: 8px"
                          class="cursor-pointer"
                          @click="handleProportionCopy3()"
                        ></Icon>
                      </div>
                      <Icon
                        type="ios-close-circle-outline"
                        style="margin-left: 8px"
                        class="cursor-pointer"
                        size="18"
                        color="red"
                        @click="handleDeleteOtherAction(index, index_1)"
                      ></Icon>
                    </div>
                    <div
                      v-else
                      class="flex align-items justify-content_end flex1"
                      style="width: 210px; flex: 0 0 auto"
                    >
                      <Icon
                        type="ios-add-circle-outline"
                        class="cursor-pointer"
                        size="18"
                        @click="handleOtherOrgAction(index, index_1)"
                      ></Icon>
                    </div>
                  </div>
                </div>
                <!-- <div v-else>--</div> -->
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <span
                  class="click-btn-430"
                  style="color: red"
                  @click="handleDelete(index)"
                >删除</span>
              </template>
            </Table>
          </div>
          <h1>配置账期周期</h1>
          <div v-if="!isMaterialShow">
            <RadioGroup v-model="formData.accountingType" vertical>
              <Radio label="1">
                <span>按月考勤节次</span>
              </Radio>
              <Radio v-if="bankName == '平安银行'" disabled label="2">
                <span>按固定时长</span>
              </Radio>
            </RadioGroup>
            <div v-if="bankName == '平安银行'" class="item">
              <Form ref="formInline" :label-width="120" inline>
                <FormItem label="冻结时间" prop="user">
                  <InputNumber
                    v-model="formData.customCycle"
                    :max="180"
                    disabled
                    @on-blur="handleInputNumberBlur()"
                    @on-change="handleInputNumberChange"
                  ></InputNumber>
                  天
                </FormItem>
                <FormItem label="结算起始时间" prop="user">
                  <DatePicker
                    type="date"
                    placeholder="请选中日期"
                    style="width: 200px"
                    :value="accountingCustomCycleBegin"
                    :disabled="disabledDatePicker"
                    disabled
                    @on-change="onDateChange"
                  ></DatePicker>
                  <p class="color-red">开始时间选定后不支持修改</p>
                </FormItem>
              </Form>
            </div>
            <RemarkCard>
              <h3>说明：</h3>
              <p>（1）按月考勤节次，次月生成上个月的结算账单;</p>
              <p v-if="bankName == '平安银行'">
                （2）按固定时长，系统按设置的结算时间范围周期（结算起始时间≤ T ≤
                结算开始时间+T，含头含尾），在结算结束时间T+1天生成对应区间的结算账单）;
              </p>
              <p v-if="bankName == '平安银行'">
                （3）按固定时长的账单周期，离班、入班、修改上课时间，均不涉及修改账单金额，与按月考勤节次不同;
              </p>
              <p>
                {{
                  `${bankName == '平安银行' ? '（4）' : '（2）'}`
                }}账期周期方式一旦设置，不可更改！
              </p>
            </RemarkCard>
          </div>
          <div v-else>
            <div style="margin: 12px 0">
              <RadioGroup v-model="materialRadio">
                <Radio label="1">
                  <span>
                    按<InputNumber
                      v-model="formData.accountingNum"
                      :max="200"
                      :min="1"
                      placeholder
                      style="margin: 0 6px"
                      :disabled="materialRadio != '1'"
                    ></InputNumber>个课时（一次性或多次）结算;
                  </span>
                </Radio>
                <Radio label="2">
                  <span>按所绑定的课程商品课时分多次结算</span>
                </Radio>
              </RadioGroup>
            </div>
            <RemarkCard>
              <h3>说明：</h3>
              <p>（1）按1个课时（一次性）结算，材料费一次性清算完成。</p>
              <p>
                （2）按所绑定的课程商品课时分多次结算，根据设置的课程商品课时，分多次结算（需手动添加至账单），请配置前务必核对清楚！
              </p>
            </RemarkCard>
          </div>
        </div>
      </div>

      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
    <ChooseOneOrgModal
      ref="chooseOneOrgModal"
      :divide-mode2="[]"
      :bank-id="bankId"
      :merchant-kind-ids="[1, 3, 4]"
      @on-finish="onOrgFinish"
    >
    </ChooseOneOrgModal>
    <ChooseApply
      ref="chooseApplyRef"
      @on-finish="onChooseApplyFinish"
    ></ChooseApply>
    <ChooseOtherOrgModal
      ref="chooseOtherOrgModalRef"
      @on-finish="onChooseOtherOrgFinish"
    ></ChooseOtherOrgModal>
  </div>
</template>

<script>

import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    ChooseOneOrgModal: () =>
      import('./ChooseOneOrgModal.vue'),
    ChooseApply: () =>
      import('./ChooseApply.vue'),
    RemarkCard: () =>
      import('@c/Base/RemarkCard.vue'),
    ChooseOtherOrgModal: () =>
      import('./ChooseOtherOrgModal.vue')
  },
  props: {
    modalWidth: {
      type: [Number, String],
      default: 75
    },
    detailsInfo: {
      type: Object,
      default: () => null
    },
    isMaterialShow: {
      type: Boolean,
      default: false
    },
    configOrgList: {
      type: Array,
      default: () => []
    },
    configTableList: {
      type: Array,
      default: () => []
    },
    inAccountType: {
      type: [Number, String],
      default: ''
    },
    configId: {
      type: String,
      default: ''
    },
    bankId: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      show: false,
      portOrg: localStorage.getItem('portOrg'),
      materialRadio: '1',
      formData: {
        accountingType: '1',
        customCycle: 7,
        customCycleBegin: '',
        accountingNum: 1
      },
      accountingCustomCycleBegin: '', // 时间控件 value
      cacheCustomCycle: '', // 编辑 缓存冻结时间
      cacheAccountingCustomCycleBegin: '', // 编辑 缓存结算起始时间
      orgTypeKeyValue: {
        4: '教培机构',
        1: '学校'
      },
      accountTypeList: [{ name: '线上结算', value: 1 }, { name: '线下结算', value: 2 }],
      tableColumn: [{
        type: 'index',
        title: '序号',
        width: 70,
        align: 'center'
      }, {
        title: '机构/学校提供方名称',
        key: 'name',
        minWidth: 180
      }, {
        title: '单位类型',
        slot: 'orgType',
        width: 120
      },
      {
        title: '所属区域',
        key: 'areaName',
        width: 180
      },
      {
        title: '结算方式',
        slot: 'divideChannel',
        width: 180
      },
      {
        title: '主体分账方【X%】的线下分账比例（线下分账比例之和，必须等于100%）',
        align: 'center',
        children: [
          {
            title: '课程方分账比例(%)',
            slot: 'proportion1',
            align: 'center',
            width: 150
          }, {
            title: '平台分账比例(%)',
            slot: 'proportion2',
            align: 'center',
            width: 150
          }, {
            title: '其他方分账比例(%)',
            slot: 'proportion3',
            align: 'center',
            width: 240
          }]
      },
      {
        title: '操作',
        slot: 'action',
        width: 150,
        align: 'center'
      }
      ],
      selectIndex: -1,
      tableData: [],
      loading: false,
      orgId: '', // 资金入账方id
      accountNo: '', // 资金入账方 账户号
      acctName: '', // 资金入账 商户名称
      acctOrgId: '',
      wxMchName: '',
      wxMchId: '',
      selectOtherIndex: -1,
      selectSubOtherIndex: -1,
      platformId: ''

    };
  },
  computed: {
    disabledDatePicker() {
      return !!this.accountingCustomCycleBegin;
    },
    showOfflineIndex() {
      return this.tableData.findIndex(item => { return item.divideChannel == 2; });
    }
    // 是否是材料费类规则
  },
  created() {
    this.getPlatformInfo();
  },
  mounted() {

  },
  methods: {
    getProportion1Input(index) {
      const item = this.tableData[index];
      const input1 = this.tableData[index]['proportion1'];
      console.log(input1);
      if (input1 && +input1 === 100 && item.orgId == this.acctOrgId) {
        // this.tableData[index]['divideChannel'] = 1;
        this.tableData.splice(index, 1, { ...item, divideChannel: 1 });
      } else {
        // this.tableData[index]['divideChannel'] = 2;
        this.tableData.splice(index, 1, { ...item, divideChannel: 2 });
      }
    },
    handleApply() {
      if (!this.acctName && !this.wxMchName) {
        this.$Message.warning('请先选择资金入账方');
        return null;
      }
      const orgList = this.tableData.map(item => {
        return {
          offerOrgId: item.orgId
        };
      });
      const list = [...orgList, ...this.configOrgList];
      this.$refs.chooseApplyRef.open(list);
    },
    // 行政区域改变
    onAreaChange(area) {
    },
    onChooseApplyFinish(data) {
      data.forEach(item => {
        item.divideChannel = item.orgId == this.acctOrgId ? 1 : 2;
        item.proportion1 = 0;
        item.proportion2 = 0;
        item.proportion3 = null;
        item.otherProportions = [{
          otherOrgId: '',
          otherOrgName: '',
          otherOrgAction: false,
          proportion: null
        }];
        item.otherOrgId = '';
        item.otherOrgName = '';
        item.otherOrgAction = false;
        item.platProportion = null;
      });
      this.tableData = [...this.tableData, ...data];
      console.log(this.tableData);
    },
    handleOpen(detailsInfo) {
      this.tableData = [];
      this.acctName = '';
      this.accountNo = '';
      this.materialRadio = '1';
      this.setTableTitle(detailsInfo);
      this.wxMchName = detailsInfo.wxMchName;
      this.wxMchId = detailsInfo.wxMchId;
      this.orgId = this.inAccountType == 3 ? '' : '';
      this.show = true;
      if (this.configTableList.length > 0) {
        this.acctName = this.configTableList[0]['acctName'];
        this.accountNo = this.configTableList[0]['acctNo'];
        this.orgId = this.configTableList[0]['orgId'];
      }
    },
    setTableTitle(detailsInfo) {
      let num = detailsInfo.proportion / 100;
      if (this.bankId == 10002) {
        num = (detailsInfo.proportion - detailsInfo.platServiceRate) / 100;
      }
      this.tableColumn[this.tableColumn.length - 2]['title'] = `主体分账方【${num}%】的线下分账比例（线下分账比例之和，必须等于100%）`;
    },
    onOrgFinish(data) {
      this.accountNo = data.acctNo;
      this.acctName = data.acctName;
      this.acctOrgId = data.orgId;
    },
    handleSelect() {
      this.$refs.chooseOneOrgModal.handleOpen();
    },
    handleCancel() {
      this.show = false;
    },
    handleOk(data) {
      if (!this.checkParameter()) {
        return null;
      }
      this.saveDivideConfigRelateOrg();
    },
    handleDelete(index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确定删除？</p>',
        onOk: () => {
          this.tableData.splice(index, 1);
        },
        onCancel: () => {
        }
      });
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
    },
    handleAccTypeCopy(val) {
      this.tableData.forEach(item => {
        item.divideChannel = val;
      });
      this.tableData = Object.assign([], this.tableData);
    },
    async getPlatformInfo() {
      const params = {
        pageNo: 1,
        pageSize: 10,

        orgType: 6
      };
      const res = await orderCenterApi.getorgPageList(params);
      if (res.status == 200 && res.message.list.length) {
        this.platformId = res.message.list[0]['orgId'];
      }
    },
    handleDeleteOtherAction(index, subIndex) {
      const otherProportions = this.tableData[index]['otherProportions'];
      console.log(this.tableData[index]);
      if (otherProportions.length > 1) {
        this.tableData[index]['otherProportions'].splice(subIndex, 1);
      } else {
        this.tableData[index]['otherProportions'] = [{
          otherOrgId: '',
          otherOrgName: '',
          otherOrgAction: false,
          proportion: null
        }];
      }
      this.tableData = Object.assign([], this.tableData);
    },
    handleOtherOrgAction(index, subIndex) {
      this.selectOtherIndex = index;
      this.selectSubOtherIndex = subIndex;
      const otherProportions = this.tableData[index]['otherProportions'];
      const subIds = otherProportions.map(item => { return item.otherOrgId; });
      this.$refs.chooseOtherOrgModalRef.handleOpen(this.tableData[index]['orgId'], subIds);
    },
    onChooseOtherOrgFinish(row) {
      this.tableData[this.selectOtherIndex]['otherProportions'][this.selectSubOtherIndex]['otherOrgId'] = row.orgId;
      this.tableData[this.selectOtherIndex]['otherProportions'][this.selectSubOtherIndex]['otherOrgName'] = row.name;
      this.tableData[this.selectOtherIndex]['otherProportions'][this.selectSubOtherIndex]['otherOrgAction'] = true;
      this.tableData[this.selectOtherIndex]['otherProportions'][this.selectSubOtherIndex]['proportion'] = null;
      this.tableData[this.selectOtherIndex]['otherProportions'].push({
        otherOrgId: '',
        otherOrgName: '',
        otherOrgAction: false,
        proportion: null
      });
      this.tableData = Object.assign([], this.tableData);
    },
    handleProportionCopy1() {
      const proportion = this.tableData[this.showOfflineIndex]['proportion1'];
      this.tableData.forEach(item => {
        // item.divideChannel == 2 ? item.proportion1 = proportion : 0
        item.proportion1 = proportion;
        //   item.platProportion = platProportion
      });
      this.tableData = Object.assign([], this.tableData);
    },
    handleProportionCopy2() {
      const proportion = this.tableData[this.showOfflineIndex]['proportion2'];
      this.tableData.forEach(item => {
        // item.divideChannel == 2 ? item.proportion2 = proportion : ''
        item.proportion2 = proportion;
        // item.platProportion = platProportion
      });
      this.tableData = Object.assign([], this.tableData);
    },
    handleProportionCopy3() {
      const proportion = this.tableData[this.showOfflineIndex]['otherProportions'][0]['proportion'];
      this.tableData.forEach(item => {
        // item.divideChannel == 2 ? item.proportion3 = proportion : ''
        //  item.proportion3 = proportion
        // item.platProportion = platProportion
        item.otherProportions.forEach(subItem => {
          subItem.proportion = proportion;
        });
      });
      this.tableData = Object.assign([], this.tableData);
    },
    checkParameter() {
      let status = true;
      if (this.inAccountType != 3) {
        if (!this.accountNo) {
          this.$Message.warning('请选择资金入账方');
          return false;
        }
      }
      if (this.tableData.length == 0) {
        this.$Message.warning('请选择课程提供方');
        return false;
      }
      for (let i = 0, len = this.tableData.length; i < len; i++) {
        const row = this.tableData[i];
        if (!row.divideChannel) {
          status = false;
          this.$Message.warning(`${this.tableData[i]['name']}：请先选择结算方式！`);
          break;
        }
        if (row.divideChannel == 2 && (row.proportion1 === null || row.proportion1 === '')) {
          status = false;
          this.$Message.warning(`${this.tableData[i]['name']}：请先输入课程方分账比例！`);
          break;
        }
        if (row.divideChannel == 2 && (row.proportion2 === null || row.proportion2 === '')) {
          status = false;
          this.$Message.warning(`${this.tableData[i]['name']}：请先输入平台分账比例！`);
          break;
        }
        if (row.divideChannel == 2) {
          const subLen = row.otherProportions.length;
          for (let k = 0; k < subLen; k++) {
            if (row.otherProportions[k]['otherOrgName'] && (row.otherProportions[k]['proportion'] === null || row.otherProportions[k]['proportion'] === '')) {
              status = false;
              this.$Message.warning(`${this.tableData[i]['name']}：请先输入${row.otherProportions[k]['otherOrgName']}分账比例！`);

              return status;
            }
          }
        }
        const otherProportion = row.otherProportions.reduce((total, current, index) => {
          console.log(current);
          return total + Number(current.otherOrgId ? current.proportion : 0);
        }, 0);

        console.log(row.proportion1 + row.proportion2 + otherProportion, row.proportion1, row.proportion2, otherProportion);
        if (row.divideChannel == 2 && ((Number(row.proportion1) + Number(row.proportion2) + otherProportion) != 100)) {
          status = false;
          this.$Message.warning(`${this.tableData[i]['name']}：课程方分账比例、平台分账比例 和其他方分账比例相加要等于100%`);
          break;
        }
      }
      if (this.formData.accountingType == 2) {
        if (!this.formData.customCycle) {
          this.$Message.warning('请输入冻结时间');
          return null;
        }
        if (this.formData.customCycle < 7) {
          this.$Message.warning('冻结时间不能设置小于7天');
          return null;
        }
        if (this.formData.customCycle > 180) {
          this.$Message.warning('冻结时间不能设置大于180天');
          return null;
        }

        if (!this.formData.customCycleBegin) {
          this.$Message.warning('请输入结算起始时间');
          return null;
        }
      }
      return status;
    },
    getMainItemOrgRelInfoList() {
      const offerOrgInfoList = [];
      this.tableData.forEach(item => {
        const divideOrgId = [{
          orgId: item.orgId,
          proportion: item.proportion1 * 100
        }, {
          orgId: this.platformId,
          proportion: item.proportion2 * 100
        }];
        // if (item.otherOrgId) {
        //   divideOrgId.push({
        //     orgId: item.otherOrgId,
        //     proportion: item.proportion3 * 100
        //   })
        // }
        item.otherProportions.forEach(subItem => {
          if (subItem.otherOrgId) {
            divideOrgId.push({
              orgId: subItem.otherOrgId,
              proportion: subItem.proportion * 100
            });
          }
        });
        offerOrgInfoList.push({
          offerOrgId: item.orgId,
          divideChannel: item.divideChannel,
          divideOrgId: divideOrgId
        });
      });
      return [{
        orgId: this.orgId,
        accountNo: this.accountNo,
        offerOrgInfoList: offerOrgInfoList
      }];
    },
    // 提交关联主分账方
    async saveDivideConfigRelateOrg(selectList) {
      const parameter = {
        configId: this.configId,
        accountingType: Number(this.formData.accountingType),
        customCycle: this.formData.accountingType == 1 ? null : this.formData.customCycle,
        customCycleBegin: this.formData.accountingType == 1 ? null : `${this.formData.customCycleBegin} 00:00:00`,
        accountingNum: 0,
        mainItemOrgRelInfoList: this.getMainItemOrgRelInfoList()
      };
      if (this.isMaterialShow) {
        parameter.accountingNum = this.materialRadio == 1 ? this.formData.accountingNum : 0;
      }
      this.$Spin.show();
      //   this.inAccountType == 3 ? parameter.orgIdList = selectList : parameter.accountNoList = selectList;
      const res = await orderCenterApi.saveDivideConfigRelateOrg(parameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('设置成功');
        this.show = false;
        this.$emit('on-finish',);
      }
    },
    handleClickRow(index) {
      this.selectIndex = index;
    },
    onDivideChannelChange(val) {
      // this.$nextTick(() => {
      //   this.tableData.splice(this.selectIndex, 1, this.tableData[this.selectIndex])
      // })
      this.$set(this.tableData, this.selectIndex, this.tableData[this.selectIndex]);
    },
    onDateChange(date) {
      this.formData.customCycleBegin = date;
    },
    // 输入框值变化
    handleInputNumberChange(num) {
      // if (this.type == 'add') {
      //   return null;
      // }
      if (num == this.cacheCustomCycle) {
        this.formData.customCycleBegin = this.cacheAccountingCustomCycleBegin;
        this.accountingCustomCycleBegin = this.cacheAccountingCustomCycleBegin;
      } else {
        this.formData.customCycleBegin = getAddDate();
        this.accountingCustomCycleBegin = getAddDate();
      }
    },

    // 输入框失焦
    handleInputNumberBlur() {
      if (this.formData.customCycle < 7) {
        this.formData.customCycle = 7;
      }
    },
    showCopyIcon(index, subIndex) {
      return index == this.showOfflineIndex && subIndex == 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.otherOrgName {
  width: 80px;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main {
  display: flex;

  .left {
    width: calc(100% - 400px);
    margin-right: 16px;
  }

  .right {
    width: 400px;

    .select-list-wrap {
      max-height: 500px;
      overflow-y: scroll;
      padding: 10px 10px 0;
      border-radius: 4px;
      background-color: #eee;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 14px;
      }
    }
  }
}
</style>
